// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2A6s1","image":"Header_image__3gZ0u","name":"Header_name__34W4y","info":"Header_info__1HQBb","infoRow":"Header_infoRow__BaVhD"};